import ViewController from 'js/app/controllers/ViewController'
import HomeViewController from 'js/app/controllers/HomeViewController'
import CompanyViewController from 'js/app/controllers/CompanyViewController'
import TeamsViewController from 'js/app/controllers/TeamsViewController'
import NewsSingleViewController from 'js/app/controllers/NewsSingleViewController'
import CareerHomeViewController from 'js/app/controllers/CareerHomeViewController'
import CareerSingleViewController from 'js/app/controllers/CareerSingleViewController'
import ContactHomeViewController from 'js/app/controllers/ContactHomeViewController'
import BusinessSingleViewController from 'js/app/controllers/BusinessSingleViewController'

export default {
  default: ViewController,
  Home: HomeViewController,
  Company: CompanyViewController,
  Staff: TeamsViewController,
  NewsSingle: NewsSingleViewController,
  CareerHome: CareerHomeViewController,
  CareerSingle: CareerSingleViewController,
  ContactHome: ContactHomeViewController,
  BusinessSingle: BusinessSingleViewController,
  BusinessManagement: BusinessSingleViewController,
  BusinessContentsProduction: BusinessSingleViewController,
  BusinessMerchandise: BusinessSingleViewController,
  BusinessMarketing: BusinessSingleViewController,
}